export default __webpack_public_path__ + "static/media/renewal.a01aaaa1.png";